import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "d-flex flex-column gap-10 mt-5 w-100 show" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_bt_modal = _resolveComponent("base-bt-modal")!

  return (_openBlock(), _createBlock(_component_base_bt_modal, {
    id: "valuation-typology-modal",
    "data-cy": "valuation-typology-modal",
    "show-modal": _ctx.show,
    "custom-modal-header-classes": "d-flex p-0 py-15",
    "custom-modal-body-classes": "p-0 pb-20",
    "with-custom-header": true,
    onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-valuation-typology-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", {
        class: "f-18",
        innerHTML: _ctx.wkLabels.typology
      }, null, 8 /* PROPS */, _hoisted_1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.residentialTypologiesFiltered, (residentialTypology) => {
          return (_openBlock(), _createBlock(_component_base_button, {
            key: `typology_${residentialTypology.id}`,
            type: "button",
            "data-value": residentialTypology.id,
            "btn-class": `btn-single-selection py-10 text-start ${_ctx.isSelected(residentialTypology.id)?' active':''}`,
            onClick: ($event: any) => (_ctx.manageTypologySelected(residentialTypology))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(residentialTypology.label), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-value", "btn-class", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal"]))
}